import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PaymentInformation from './PaymentInformation'
import ThingsToKnow from './ThingsToKnow'
import WirelessMigrationForm from '../forms/WirelessMigrationForm'
import globals from '../globals'

const MigrateWireless = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [plans, setPlans] = useState([])

    useEffect(() => {
        DataSource.getData(`/api/getMobileMigrationPlans/${props.serviceId}`, result => {
            setIsLoaded(true)
            setPlans(result.plans)
        }, () => {
            setIsLoaded(true)
            setHasError(true)
        })
    }, [])

    const handleSuccess = (response, state) => {
        globals.pushEvent('MobilePlanChangeSubmit', { planName: state.planObj.title })
    }

    return (
        <div>
            <div className='module'>
                <Heading title='Migrate my service' />
                <ModuleWithLoader isLoaded={isLoaded} hasError={hasError}>
                    <div className='p-4'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p className='lh'><span className='bold'>IMPORTANT:</span> Your Home Wireless Broadband service on the Optus network will be cancelled on 31 July 2022. To continue using your Exetel Home Wireless Broadband service you will need to migrate your service to one of no lock-in plans on the Telstra network before this date. Please choose a migration plan asap, and we’ll send you a new SIM card which is compatible with your current modem.</p>
                            </div>
                        </div>
                        <WirelessMigrationForm
                            plans={plans}
                            serviceId={props.serviceId}
                            serviceDetails={props.serviceDetails}
                            handleSuccess={handleSuccess}
                        />
                    </div>
                </ModuleWithLoader>
            </div>
            {plans.length > 0
                ? <React.Fragment>
                    <PaymentInformation />
                    <ThingsToKnow type='migrateWireless' />
                  </React.Fragment>
                : ''}
        </div>
    )
}

MigrateWireless.propTypes = {}

export default MigrateWireless



// WEBPACK FOOTER //
// ./resources/js/modules/MigrateWireless.js